import ActionsEventGateway from "../features/event-gateway/components/actions-event-gatewayt"

export default function EventGatewayView() {
  return(
    <>
      <h1>Gateway events</h1>
      <ActionsEventGateway/>
    </>
  )
}